var styles = {"item":"styles_item__3Gv3F","none":"styles_none__3jj7_","extra-tight":"styles_extra-tight__9332O","extraTight":"styles_extra-tight__9332O","tight":"styles_tight__3mrja","normal":"styles_normal__22KdM","loose":"styles_loose__3WIh9","extra-loose":"styles_extra-loose__3GTFd","extraLoose":"styles_extra-loose__3GTFd"};

export default styles;
//# sourceMappingURL=styles.css.js.map
